export default {
      id: "fund-full-usage",
      viewBox: "0 0 20 20",
      url: "/assets/" + "icons.svg#fund-full",
      toString: function () {
        return this.url;
      }
    }